import { withStyles } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import React from "react";
import { TableDataTransaction } from "../../../containers/ComptePage/helpers";
import { HeadCell } from "../helpers";
import styles from "../styles";

interface Props {
  classes?: any;
  row: TableDataTransaction;
  labelId: string;
  headCells: HeadCell[];
}
function EnhancedTableRow(props: Props) {
  const { classes, row, labelId } = props;

  return (
    <>
      <TableRow
        hover
        classes={{
          root: classes.tableRow,
        }}
        role="checkbox"
        tabIndex={-1}
        key={row.detail + " " + row.montant}
      >
        {Object.values(row)
          .filter((r) => typeof r !== "object")
          .map((r, i) => {
            const findKey = Object.keys(row)[i];

            return (
              <TableCell
                id={labelId + row.montant}
                sortDirection={false}
                className={findKey}
              >
                <div className={classes.cellValue}>{r}</div>
              </TableCell>
            );
          })}
      </TableRow>
    </>
  );
}

export default withStyles(styles)(EnhancedTableRow);
